import {
  ANALYTICS_EXPORT_TIMEFRAME,
  EXTENDED_ANALYTICS_EXPORT_SECTION,
} from '../../../../../Reports/types';

export const TIMEFRAME_COPY = {
  [ANALYTICS_EXPORT_TIMEFRAME.SEVEN_DAYS]: 'last7Days',
  [ANALYTICS_EXPORT_TIMEFRAME.THIRTY_DAYS]: 'last30Days',
  [ANALYTICS_EXPORT_TIMEFRAME.SIXTY_DAYS]: 'last60Days',
  [ANALYTICS_EXPORT_TIMEFRAME.OVERALL]: 'overall',
};

export const EXPORT_SECTION_TITLE_COPY = {
  [EXTENDED_ANALYTICS_EXPORT_SECTION.HOT_LEADS]: 'hotLeads',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.COLD_LEDS]: 'coldLeads',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.VISIT_STATS]: 'visitStats',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.SECURE_LINKS]: 'secureLinks',

  [EXTENDED_ANALYTICS_EXPORT_SECTION.MEMBERS]: 'topRankedMember',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.NODES]: 'topFiles',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.STAGE]: 'questionStages',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.SUBJECTS]: 'questionSubjects',
};

export const EXPORT_SECTION_DESCRIPTION_COPY = {
  [EXTENDED_ANALYTICS_EXPORT_SECTION.HOT_LEADS]: 'hotLeadsOptionDescription',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.COLD_LEDS]: 'coldLeadsOptionDescription',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.VISIT_STATS]:
    'visitStatsOptionDescription',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.SECURE_LINKS]:
    'secureLinksOptionDescription',

  [EXTENDED_ANALYTICS_EXPORT_SECTION.MEMBERS]:
    'memberActivityDownloadsAndViews',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.NODES]: 'mostViewedAndDownloadedFiles',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.STAGE]: 'questionActivityByStage',
  [EXTENDED_ANALYTICS_EXPORT_SECTION.SUBJECTS]: 'questionActivityBySubject',
};
